import { useState, useEffect } from "react";
import { useChartBar } from "../../hooks";

export default function Module_HealthAnalysisManagement_BarCompany({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
  exportData = [],
  callMainAPI = () => null,
}) {
  const { renderBar } = useChartBar({
    setting: moduleData,
    isExportRawList: true,
  });
  const [chartData, setChartData] = useState({ raw: [], format: [] });

  useEffect(() => {
    const data = [
      {
        type: "集團",
        aa: 57,
      },
      {
        type: "投控",
        aa: 62,
      },
      {
        type: "連展",
        aa: 58,
      },
      {
        type: "連訊",
        aa: 60,
      },
      {
        type: "連騰",
        aa: 54,
      },
      {
        type: "連淨",
        aa: 54,
      },
      {
        type: "電能",
        aa: 60,
      },
    ];
    setChartData({
      raw: data,
      format: data,
      export: null,
    });
  }, []);

  return (
    <>
      <div className="w-full overflow-auto">
        {renderBar({
          moduleTitle,
          options: {
            moduleData: {
              ...moduleData,
              // columns: [{ key: "uv" }, { key: "sv" }, { key: "pv" }],
            },
            chartData,
            callMainAPI,
          },
        })}
      </div>
    </>
  );
}
